import { connect } from 'react-redux'

import DashboardComponent from '../../components/dashboard/dashboard.component'
import {
  getCustomersChart,
  getInvoiceChart,
  getUserTaxInfo,
  getUserCompanyUpdateInfo,
  onTokenValidation,
  getAdminUsersList,
  loadProfileStart,
  incrementYear,
  decrementYear,
  resetYear,
  getInvoicesStart,
  getReferralDiscountByEmail,
  closeDialogDashboard,
  getUserLifeTimeInfo,
  updateCelebrationStatus,
  getInvoiceAndSalaryDetailMonthly
} from '../../actions'

const mapStateToProps = (state) => {
  const { client, adminUser } = state
  const userType = client.user.data[5]

  // Bar chart datasets handled
  const monthly_invoicing = state.dashboard.invoiceAmountByMonthlyChartData
  const gross_salary = state.dashboard.grossSalaryMonthlyChartData
  const raised_salary = state.dashboard.raisedSalaryMonthlyChartData
  // Combine datasets
  const invoiceAmountByMonthlyChartData = {
    labels: [],
    datasets: []
  }
  // Function to check if a dataset is empty
  const isDatasetEmpty = (dataset) =>
    !dataset || !dataset.datasets || dataset.datasets.length === 0
  // Add non-empty datasets to combinedDatasets
  if (!isDatasetEmpty(monthly_invoicing)) {
    invoiceAmountByMonthlyChartData.labels = monthly_invoicing.labels
    invoiceAmountByMonthlyChartData.datasets.push(...monthly_invoicing.datasets)
  }
  if (!isDatasetEmpty(gross_salary)) {
    invoiceAmountByMonthlyChartData.datasets.push(...gross_salary.datasets)
  }
  if (!isDatasetEmpty(raised_salary)) {
    invoiceAmountByMonthlyChartData.datasets.push(...raised_salary.datasets)
  }
  return {
    state,
    topCustomers: state.dashboard.topCustomers,
    invoiceChartData: state.dashboard.invoiceChartData,
    invoiceAmountByMonthlyChartData: invoiceAmountByMonthlyChartData,
    userType,
    selectedUser: adminUser.selectedUser,
    year: state.dashboard.year,
    noCampaign: state.dashboard.noCampaign,
    showPopup: state.dashboard.showPopup,
    total_invoiced_amount: state.dashboard.total_invoiced_amount,
    reachAnAward: state.dashboard.reachAnAward,
    service_percentage: state.dashboard.service_percentage
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    //checkAuthInfo: () => dispatch(checkAuthInfo()),
    getCustomersChart: () => dispatch(getCustomersChart()),
    getInvoiceChart: () => dispatch(getInvoiceChart()),
    getUserTaxInfo: () => dispatch(getUserTaxInfo()),
    getUserCompanyUpdateInfo: (data) =>
      dispatch(getUserCompanyUpdateInfo(data)),
    onTokenValidation: () => dispatch(onTokenValidation()),
    getAdminUsersList: () => dispatch(getAdminUsersList()),
    loadProfileStart: (result) => dispatch(loadProfileStart(result)),
    incrementYear: () => dispatch(incrementYear()),
    decrementYear: () => dispatch(decrementYear()),
    resetYear: () => dispatch(resetYear()),
    getInvoicesStart: () => dispatch(getInvoicesStart()),
    getReferralDiscountByEmail: (data) =>
      dispatch(getReferralDiscountByEmail(data)),
    closeDialogDashboard: () => dispatch(closeDialogDashboard()),
    getUserLifeTimeInfo: (data) => dispatch(getUserLifeTimeInfo(data)),
    updateCelebrationStatus: () => dispatch(updateCelebrationStatus()),
    getInvoiceAndSalaryDetailMonthly: (data) =>
      dispatch(getInvoiceAndSalaryDetailMonthly(data))
  }
}

const DashboardContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardComponent)

export default DashboardContainer
